module.exports = __webpack_public_path__ + "img/фон_мобильный-в.1195e181.jpg";